import { io } from "socket.io-client";
import { authorizationHeaders, hasBasicAuth, usesDevAuthProxy } from "./lib/basicAuth";

const URL = process.env.REACT_APP_SOCKET_URL;
const devProxy = usesDevAuthProxy();

// Browsers cannot set Authorization on a WebSocket upgrade, so a direct
// connection stays on polling. The local dev proxy adds Basic auth itself.
const socketOptions = {
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
};

if (!devProxy && hasBasicAuth()) {
    socketOptions.extraHeaders = authorizationHeaders();
    socketOptions.transports = ["polling"];
}

export const socket = devProxy
    ? io({ ...socketOptions, path: "/socket-proxy/socket.io" })
    : io(URL, socketOptions);


